import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { formatNumber } from "helpers/numbers"
import "./index.scss"

interface TooltipProps {
	active?: boolean
	payload?: any[]
	label?: string
}

const Tooltip: React.FC<TooltipProps> = ({ active, payload = [] }) => {
	const canBeShown = active && payload?.length
	const tooltipName =
		"phronesis.customerbehavior.application.customerProfiling.timeline.tooltip."
	const intl = useIntl()
	const title = payload[0]?.payload.date

	return canBeShown ? (
		<div className="customer-profiling-timeline-tooltip">
			<div className="title">{title}</div>
			{payload?.map((item) => (
				<div key={item.dataKey} className="label">
					<div className="color" style={{ background: item.color }} />
					<FormattedMessage
						id={tooltipName + item.dataKey}
						values={{ number: formatNumber(item.value, intl) }}
					/>
				</div>
			))}
		</div>
	) : (
		<React.Fragment />
	)
}
export default Tooltip
